import React from "react";
import Reveal from "../components/Reveal";

const sections = [
  { h: "Our Commitment to Confidentiality", p: "Recovery Leaders understands that fraud victims share sensitive personal and financial information. We treat every communication as strictly confidential and use it only to provide guidance about your situation." },
  { h: "Information We Collect", p: "We collect the information you voluntarily provide through our contact form and consultations, such as your name, email address, phone number, and details about your situation. We do not sell or rent your personal information to third parties." },
  { h: "How We Use Your Information", p: "Your information is used solely to respond to your enquiry, assess your case, and provide educational guidance about recovery options. We may contact you only if you have asked us to." },
  { h: "Data Security", p: "We apply reasonable technical and organizational measures to protect your information. Access to sensitive case files is restricted and secured behind private access controls." },
  { h: "No Guarantee & Educational Purpose", p: "The information provided is for educational purposes and is not legal or financial advice. We make no guarantee of fund recovery." },
  { h: "Your Rights", p: "You may request access to, correction of, or deletion of your personal information at any time by emailing support@recovery-leaders.com." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="hero-mesh section">
        <div className="container max-w-3xl">
          <Reveal>
            <h1 className="mb-4 font-display text-4xl font-extrabold tracking-tight text-primary md:text-5xl">Privacy Policy</h1>
            <p className="text-muted-foreground">Your privacy and confidentiality are central to how we operate. Last updated {new Date().getFullYear()}.</p>
          </Reveal>
        </div>
      </section>
      <section className="section">
        <div className="container max-w-3xl space-y-8">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.04}>
              <div>
                <h2 className="mb-2 font-display text-xl font-semibold">{s.h}</h2>
                <p className="text-muted-foreground">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
